module.exports = __webpack_public_path__ + "img/appAsset-brand--sri.674d1475.svg";